<mat-form-field class="moneytor-input auto-complete textarea">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <mat-chip-grid #chipList aria-label="auto complete section">
    @for (option of searchedOption; track option) {
      <mat-chip
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(option)"
        >
        {{ option }}
        @if (removable) {
          <mat-icon matChipRemove>clear</mat-icon>
        }
      </mat-chip>
    }

    <input
      #searchInput
      matInput
      name="placeholder"
      [placeholder]="placeholder"
      type="type"
      [required]="required"
      [matAutocomplete]="auto"
      [formControl]="autocompleteControl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (option of options; track option) {
      <mat-option [value]="value ? option[value] : option">
        {{ display ? option[display] : option }}
      </mat-option>
    }

    @if (options && options.length < 1 && noDataFound) {
      <mat-option>{{ 'No records found' }}</mat-option>
    }
  </mat-autocomplete>
  @if (loading) {
    <span matSuffix class="ic_refresh rotate ml-5"></span>
  }
</mat-form-field>
